import {makeEl} from "../../common/Utils";
import DataStore from "../DataStore";
import {svgIcoBtnChange, svgIcoChangeList} from "../SvgCode";
import Layer from "../Layer";
import { countryType, langType, IlanguageCountry } from '../../interface/IFooter';

export default  class LanguageCountry{
    private ds: DataStore;
    private btn!: HTMLButtonElement;
    private ul!: HTMLUListElement;

    constructor(_wrapper: HTMLElement) {
        this.ds = DataStore.instance;
        if(this.ds.config.languageCountryList && this.ds.config.languageCountryList.length> 0){
            this.templ(_wrapper);
            this.addEvents();
        }
    }

    templ(_parent: HTMLElement){
        const tmpl = makeEl('div', _parent, {class: 'footer-change-inner footer-change-lanco'});
        this.btn = makeEl('button', tmpl, {class: 'btn-footer-change'});
        this.ul = makeEl('ul', tmpl, {class: 'footer-change-list', id: 'FooterLanguageCountryChangeList'});
        this.ds.config.languageCountryList.map(it => this.liTempl(this.ul, it, svgIcoChangeList));
    }

    liTempl(_parent: HTMLUListElement, _data: IlanguageCountry, _svgCode: string){
        const li = makeEl('li', _parent, {class: 'footer-change-item'});
        const QLocale = _data.qLocale;
        const domain = (_data.domain || window.location.protocol + '//' + location.hostname).replace(/\/$/, "");;

        let aEl;

        // url 옵션이 있으면 도메인+패스+쿼리를 통째로 사용. 상대경로로 넣으면 domain(없으면 현재 도메인) 기준으로 붙는다
        if(_data.url){
          const newURL = new URL(_data.url, domain);
          this.setParams(newURL, _data.params);

          aEl = makeEl('a', li, {class: 'change-item-link', href: newURL.toString(), 'data-code': _data.code});
        // qLocale 옵션이 있으면 url 뒤에 쿼리스트링으로 ?qLocale이=data-code 붙게 되고
        }else if(QLocale){
          aEl = makeEl('a', li, {class: 'change-item-link', href: domain + '/#', 'data-code': _data.code});

          // CSR 페이지를 위하여, 클릭 이벤트 형식으로 붙임.
          // Next 쓸때, pushState 이벤트를 감지 할수 있나? popstate 이벤트로는 감지가 안되는거 같음
          aEl.addEventListener('click', (e)=>{
            e.preventDefault();

            let newURL = new URL(location.href);
            newURL.searchParams.set(QLocale , _data.path || _data.code);
            this.setParams(newURL, _data.params);

            window.location.href = newURL.toString();
          })
        // path가 있거나, code만 있으면 root path에 해당 값이 들어가게 된다
        }else{
          const path = _data.path? _data.path: _data.code;
          const newURL = new URL(domain + '/' + path + '/index');
          this.setParams(newURL, _data.params);

          aEl = makeEl('a', li, {class: 'change-item-link', href: newURL.toString(), 'data-code': _data.code});
        }

        // 현재의 lang-locale에 해당하는 옵션에 체크 표시
        if(_data.code.toLowerCase() === this.ds.lang+'-'+this.ds.country.toLowerCase()){
          aEl.innerHTML= _svgCode;
          makeEl('strong', aEl, undefined, _data.title);
          this.btn.innerHTML= `<span class="inner-txt">${_data.title}</span>${svgIcoBtnChange}`;
        } else {
          makeEl('span', aEl, undefined, _data.title);
        }
    }

    // params 옵션으로 받은 값을 쿼리스트링에 추가 (ex. {redirect: 'false'} -> ?redirect=false)
    setParams(_url: URL, _params?: {[key: string]: string}){
        if(!_params) return;

        for(let key in _params){
          _url.searchParams.set(key, _params[key]);
        }
    }

    addEvents(){
        this.btn.addEventListener('click', e => {
            Layer.toggleLayer(this.ul.id);
            e.stopPropagation();
        });
    }
}
